import { combineReducers } from 'redux'
import { Template } from '../admin/templates/edit-template/template.reducer'
import { folders } from '../admin/templates/folders/folders.reducer'
import { Auth } from '../authed/auth.reducer'
import { Datasets } from '../datasets/datasets.reducer'
import { snackbar } from '../global/snackbar/snackbar.reducer'
import { Submissions } from '../submissions/submissions.reducer'

export const rootReducer = combineReducers({
  Auth,
  Datasets,
  Submissions,
  Snackbar: snackbar.reducer,
  Template,
  Folders: folders.reducer,
})
